import * as battery0 from '@/../images/icons/his/battery0.svg'
import * as battery20 from '@/../images/icons/his/battery20.svg'
import * as battery40 from '@/../images/icons/his/battery40.svg'
import * as battery60 from '@/../images/icons/his/battery60.svg'
import * as battery80 from '@/../images/icons/his/battery80.svg'
import * as battery100 from '@/../images/icons/his/battery100.svg'
import * as chp from '@/../images/icons/his/chp.svg'
// import * as container from '@/../images/icons/his/container.svg'
import * as wallbox from '@/../images/icons/his/wallbox.svg'
import * as wallboxPlugged from '@/../images/icons/his/wallbox_plugged.svg'
import * as wallboxUnplugged from '@/../images/icons/his/wallbox_unplugged.svg'
import * as wallboxWarning from '@/../images/icons/his/wallbox_warning.svg'
// import * as fuelcell from '@/../images/icons/his/fuelcell.svg'
import * as generic from '@/../images/icons/his/generic.svg'
import * as grid from '@/../images/icons/his/grid.svg'
import * as heatingelement from '@/../images/icons/his/heatingelement.svg'
import * as heatpump from '@/../images/icons/his/heatpump.svg'
import * as pv from '@/../images/icons/his/pv.svg'
import * as rest from '@/../images/icons/his/rest.svg'
import * as trafo from '@/../images/icons/his/trafo.svg'
import * as user from '@/../images/icons/his/user.svg'

import { ICON_MAPPING } from './icons'

const map = {
  battery: battery0,
  battery0,
  battery20,
  battery40,
  battery60,
  battery80,
  battery100,
  chp,
  // container,
  // fuelcell,
  generic,
  grid,
  heatingelement,
  heatpump,
  pv,
  rest,
  trafo,
  user,
  wallbox,
  wallboxPlugged,
  wallboxUnplugged,
  wallboxWarning
}

export function overwriteIcons() {
  Object.assign(ICON_MAPPING, map)
}
